import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { submit, isSubmitting } from 'redux-form';
import 'components/tenant_app/AppPage.css';
import 'components/landlord_app/dashboard/dashboard.css';
import 'react-table/react-table.css';
import { BounceLoader } from 'halogenium';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import FlatButton from 'material-ui/FlatButton';
import Toggle from 'material-ui/Toggle';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import moment from 'moment';
import {
  getMaintenanceInsights,
  setMaintenanceGraphLevel,
  receiveMaintenanceGraphData,
  getUserMaintenanceTickets,
} from 'actions/landlordInsightActions';
import {
  getTicket,
  getAllMaintenanceTickets,
  deleteTicket,
} from 'actions/maintenanceTicketActions';
import {
  createOrUpdateMaintenanceTicket,
  createOrUpdateMaintenanceTask,
  deleteTask,
  getAssets,
  getListOfMaintenanceStaff,
} from 'actions/maintenanceActions';
import { getCompanyPreferences } from 'actions/companyDetailsActions';
import { getGroupedVendors } from 'actions/vendorsActions';
import { getProperties, getUnits } from 'actions/landlordPropertiesActions';

import { AccentColor } from 'helpers/AccentColorHelper';
import { formatHoursDays } from 'helpers/Formatter';

import AddAndViewMaintenanceTickets from 'components/landlord_app/maintenance/components/AddAndViewMaintenanceTickets';

import AvgTimeToCompleteChart from './AvgTimeToCompleteChart';
import OpenCloseRatioChart from './OpenCloseRatioChart';
import TimeCompletePriorityChart from './TimeCompletePriorityChart';
import TimeCompleteCategoryChart from './TimeCompleteCategoryChart';
import TicketsCategoryChart from './TicketsCategoryChart';
import RespondFixCloseChart from './RespondFixCloseChart';
import { AvgInsightsTable } from './AvgInsightsTable';
import { UserTicketsTable } from './UserTicketsTable';
import { TicketsTable } from './TicketsTable';
import PerformanceTimeTable from './PerformanceTimeTable';
import AvgSatisfactionTable from './AvgSatisfactionTable';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
    padding: '15px',
  },
};

const ranges = [
  { value: '6-month', label: 'Past 6 Months' },
  { value: '3-month', label: 'Past 3 Months' },
  { value: '1-month', label: 'Past 1 Month' },
  { value: 'day', label: 'Sort by Day' },
];

export default connect(
  store => {
    return {
      maintenanceGraphData: store.landlordInsights.maintenanceGraphData,
      loadingMaintenanceGraphData: store.landlordInsights.loadingMaintenanceGraphData,
      maintenanceGraphLevel: store.landlordInsights.maintenanceGraphLevel,
      maintenanceTickets: store.maintenanceTicket.maintenanceTickets,
      insightUserMaintenanceTickets: store.landlordInsights.insightUserMaintenanceTickets,
      insightUserDetails: store.landlordInsights.insightUserDetails,
      ticketDetails: store.maintenanceTicket.ticketDetails,
      properties: store.landlordProperties.properties,
      maintenanceStaff: store.maintenanceReducer.maintenance,
      submitting: isSubmitting('add_ticket_form')(store),
      companyPreferences: store.companyDetails.companyPreferences,
    };
  },
  {
    getMaintenanceInsights,
    setMaintenanceGraphLevel,
    getTicket,
    getAssets,
    getUnits,
    getGroupedVendors,
    getAllMaintenanceTickets,
    createOrUpdateMaintenanceTicket,
    submit,
    getProperties,
    deleteTicket,
    createOrUpdateMaintenanceTask,
    deleteTask,
    getListOfMaintenanceStaff,
    getCompanyPreferences,
    receiveMaintenanceGraphData,
    getUserMaintenanceTickets,
  }
)(
  class MaintenanceInsightsDashboard extends Component {
    state = {
      range: { value: '6-month', label: 'Past 6 Months' },
      dateRange: [
        moment()
          .subtract('months', 1)
          .toDate(),
        new Date(),
      ],
      indexArray: [],
      showLabels: false,
      showTable: false,
      compare: false,
      timeSeries: false,
      timePeriod: 'days',
      showDrawer: false,
      showUserTickets: false,
    };

    UNSAFE_componentWillMount() {
      this.props.getMaintenanceInsights({ range: '6-month' });
      this.props.getCompanyPreferences();
    }

    setInsightsRange = range => {
      if (range.value === this.state.range.value) return;
      this.setState({
        range,
        indexArray: [],
        showUserTickets: false,
      });
      this.props.receiveMaintenanceGraphData({});
      if (range.value !== 'day' && range.value !== 'month') {
        this.props.getMaintenanceInsights({ range: range.value });
      }
    };

    populateDateRange = () => {
      this.props.getMaintenanceInsights({
        range: 'day',
        start_date: this.state.dateRange[0],
        end_date: this.state.dateRange[1],
      });
    };

    changeTimePeriod = () => {
      this.setState(prevState => ({
        timePeriod: prevState.timePeriod === 'days' ? 'hours' : 'days',
      }));
    };

    onChartClick = (param, type) => {
      if (!param) return;
      if (type === 'category') {
        this.stepToChild(param);
      } else if (type === 'time') {
        this.stepToTimePeriod(param);
      }
    };

    stepToTimePeriod = param => {
      if (!param instanceof Object) return;
      const { maintenanceGraphData, maintenanceGraphLevel } = this.props;

      this.setInsightsRange({ value: 'day', label: 'Sort by Day' });
      const time_stamp =
        maintenanceGraphData[maintenanceGraphLevel].time_series[param.activeTooltipIndex];
      const stepIntoDate = new Date(time_stamp * 1000);

      if (maintenanceGraphData[maintenanceGraphLevel].time_range === 'day') {
        let startOfDay = new Date(stepIntoDate);
        startOfDay.setUTCHours(0, 0, 0, 0);

        let endOfDay = new Date(stepIntoDate);
        endOfDay.setUTCHours(23, 59, 59, 999);

        this.setState({
          dateRange: [startOfDay, endOfDay],
          timeSeries: false,
          showUserTickets: false,
        });
        this.props.getMaintenanceInsights({
          range: 'day',
          start_date: startOfDay,
          end_date: endOfDay,
        });
      } else {
        const firstDay = new Date(stepIntoDate.getUTCFullYear(), stepIntoDate.getUTCMonth(), 1);
        const lastDay = new Date(stepIntoDate.getUTCFullYear(), stepIntoDate.getUTCMonth() + 1, 0);
        this.setState({
          dateRange: [firstDay, lastDay],
          showUserTickets: false,
        });
        this.props.getMaintenanceInsights({
          range: 'day',
          start_date: firstDay,
          end_date: lastDay,
        });
      }
    };

    stepToChild = param => {
      const { maintenanceGraphData, maintenanceGraphLevel } = this.props;
      const currentLevelDetails = {
        label: maintenanceGraphData[maintenanceGraphLevel].insight_type_name,
        type: maintenanceGraphData[maintenanceGraphLevel].insight_type,
        id: maintenanceGraphData[maintenanceGraphLevel].insight_id,
      };
      let indexArray = this.state.indexArray;
      indexArray.push(currentLevelDetails);
      this.setState({
        indexArray,
        showUserTickets: false,
      });

      let insightId = param;
      if (insightId instanceof Object) {
        insightId =
          maintenanceGraphData[maintenanceGraphLevel].children[param.activeTooltipIndex].insight_id;
      }
      if (insightId in maintenanceGraphData) {
        this.props.setMaintenanceGraphLevel(insightId);
      } else {
        this.props.getMaintenanceInsights({
          range: this.state.range.value,
          start_date: this.state.dateRange[0],
          end_date: this.state.dateRange[1],
          insight_id: insightId,
        });
      }
    };

    stepToParent = index => {
      const { indexArray } = this.state;
      const insightId = indexArray[index].id;
      this.setState({
        indexArray: index === 0 ? [] : this.state.indexArray.splice(0, index),
        showUserTickets: false,
      });

      if (insightId in this.props.maintenanceGraphData) {
        this.props.setMaintenanceGraphLevel(insightId);
      } else {
        this.props.getMaintenanceInsights({
          range: this.state.range.value,
          start_date: this.state.dateRange[0],
          end_date: this.state.dateRange[1],
          insight_id: insightId,
        });
      }
    };

    goToUserTickets = (userId, userName) => {
      const options = {
        range: this.state.range.value,
        start_date: this.state.dateRange[0],
        end_date: this.state.dateRange[1],
      };
      this.props.getUserMaintenanceTickets(userId, userName, options);
      this.setState({
        showUserTickets: true,
      });
    };

    createOrUpdateTask = async (task, taskID) => {
      await this.props.createOrUpdateMaintenanceTask(task, taskID, this.props.ticketDetails.id);
      this.getAllMaintenanceTickets();
    };

    deleteTask = async taskId => {
      await this.props.deleteTask(taskId, this.props.ticketDetails.id);
      this.getAllMaintenanceTickets();
    };

    createOrUpdateTask = async (task, taskID) => {
      await this.props.createOrUpdateMaintenanceTask(task, taskID, this.props.ticketDetails.id);
      this.getAllMaintenanceTickets();
    };

    updateTicket = (formData, ticketID) => {
      if (ticketID) {
        return this.props.createOrUpdateMaintenanceTicket(formData, ticketID).then(() => {
          this.getAllMaintenanceTickets();
        });
      }

      return this.props
        .createOrUpdateMaintenanceTicket(formData, this.props.ticketDetails.id)
        .then(() => {
          this.getAllMaintenanceTickets();
          this.props.getTicket(this.props.ticketDetails.id);
        });
    };

    deleteTicket = () => {
      return this.props.deleteTicket(this.props.ticketDetails.id).then(() => {
        this.toggleDrawer();
        this.getAllMaintenanceTickets();
      });
    };

    toggleDrawer = maintenanceTicketID => {
      if (this.state.showDrawer || !maintenanceTicketID) {
        this.setState({ showDrawer: false });
        return;
      }
      this.props.getTicket(maintenanceTicketID).then(() => {
        let assetParams = {
          property_id: this.props.ticketDetails.property_id,
          for_multiselect: true,
        };

        const unitId = this.props.ticketDetails.unit_id;

        if (unitId) {
          assetParams = { ...assetParams, unit_id: unitId };
        }

        this.props.getAssets(assetParams);
        this.props.getUnits(this.props.ticketDetails.property_id, { for_multiselect: true });
        this.props.getGroupedVendors();
        this.setState({
          showDrawer: true,
        });
      });
      this.props.getGroupedVendors();
      return;
    };

    render() {
      return (
        <div className="body" role="main" style={{ backgroundColor: '#f8f8f8' }}>
          <div className="centers">
            <div className="row">
              <div className="col-sm-5">
                <HeaderWithPeriod headerText="Maintenance Insights" />
                {this._renderBreadCrumb()}
              </div>
              <div className="col-sm-7">{this._renderHeader()}</div>
              <div className="col-sm-12">
                <hr />
              </div>
              {this._renderActionInsights()}
            </div>
            {this._renderGraphsLoading()}
            {this._renderGraphsLoaded()}
            {this._renderUserTickets()}
            {this._renderGraphsNotFound()}
          </div>
        </div>
      );
    }

    _renderGraphsLoading = () => {
      if (!this.props.loadingMaintenanceGraphData) return null;

      return (
        <div className="row" style={{ textAlign: 'center', marginTop: '20%' }}>
          <div
            style={{
              textAlign: 'center',
              width: '60px',
              margin: 'auto',
            }}
          >
            <BounceLoader color={AccentColor()} />
          </div>
          <p>Bear with us as we generate maintenance insights</p>
        </div>
      );
    };

    _renderGraphsNotFound = () => {
      if (
        (this.props.maintenanceGraphLevel || this.props.loadingMaintenanceGraphData) &&
        !this.state.showUserTickets
      )
        return null;
      if (
        (this.props.insightUserMaintenanceTickets.length >= 0 ||
          this.props.loadingMaintenanceGraphData) &&
        this.state.showUserTickets
      )
        return null;
      return (
        <div className="row" style={{ textAlign: 'center' }}>
          <div
            style={{
              textAlign: 'center',
              margin: 'auto',
            }}
          >
            <h3>No Insights Found.</h3>
            <p>Please select a new date range and try again.</p>
          </div>
        </div>
      );
    };

    _renderUserTickets = () => {
      if (!this.props.maintenanceGraphLevel || this.props.loadingMaintenanceGraphData) return null;
      if (!this.state.showUserTickets) return null;
      return (
        <div className="row">
          <AddAndViewMaintenanceTickets
            drawerIsOpen={false}
            showDrawer={this.state.showDrawer}
            toggleDrawer={this.toggleDrawer}
            updateTicket={this.updateTicket}
            deleteAction={this.deleteTicket}
            createOrUpdateTask={this.createOrUpdateTask}
            deleteTask={this.deleteTask}
            maintenanceTicket={this.props.ticketDetails}
            submitMaintenanceTicket={() => this.props.submit('add_ticket_form')}
            submittingMaintenance={this.props.submitting}
            companyPreferences={this.props.companyPreferences}
          />
          <UserTicketsTable
            showTable={this.state.showUserTickets}
            timePeriod={this.state.timePeriod}
            insightUserMaintenanceTickets={this.props.insightUserMaintenanceTickets}
            insightUserDetails={this.props.insightUserDetails}
            goToTicket={this.toggleDrawer}
            closeTable={() => this.setState({ showUserTickets: false })}
          />
        </div>
      );
    };

    _renderGraphsLoaded = () => {
      if (!this.props.maintenanceGraphLevel || this.props.loadingMaintenanceGraphData) return null;
      if (this.state.showUserTickets) return null;

      return (
        <Fragment>
          <div className="row">
            <AddAndViewMaintenanceTickets
              drawerIsOpen={false}
              showDrawer={this.state.showDrawer}
              toggleDrawer={this.toggleDrawer}
              updateTicket={this.updateTicket}
              deleteAction={this.deleteTicket}
              createOrUpdateTask={this.createOrUpdateTask}
              deleteTask={this.deleteTask}
              maintenanceTicket={this.props.ticketDetails}
              submitMaintenanceTicket={() => this.props.submit('add_ticket_form')}
              submittingMaintenance={this.props.submitting}
              companyPreferences={this.props.companyPreferences}
            />
            <AvgInsightsTable
              graphData={this.props.maintenanceGraphData}
              onClick={this.onChartClick}
              level={this.props.maintenanceGraphLevel}
              showTable={this.state.showTable}
              timePeriod={this.state.timePeriod}
            />
            <AvgTimeToCompleteChart
              graphData={this.props.maintenanceGraphData}
              onClick={this.onChartClick}
              level={this.props.maintenanceGraphLevel}
              showLabels={this.state.showLabels}
              timeSeries={this.state.timeSeries}
              timePeriod={this.state.timePeriod}
            />
            <RespondFixCloseChart
              graphData={this.props.maintenanceGraphData}
              onClick={this.onChartClick}
              level={this.props.maintenanceGraphLevel}
              showLabels={this.state.showLabels}
              timePeriod={this.state.timePeriod}
            />
            <TicketsCategoryChart
              graphData={this.props.maintenanceGraphData}
              onClick={this.onChartClick}
              level={this.props.maintenanceGraphLevel}
              showLabels={this.state.showLabels}
              timeSeries={this.state.timeSeries}
            />
            <OpenCloseRatioChart
              graphData={this.props.maintenanceGraphData}
              onClick={this.onChartClick}
              level={this.props.maintenanceGraphLevel}
              showLabels={this.state.showLabels}
              timeSeries={this.state.timeSeries}
            />
            <AvgSatisfactionTable
              graphData={this.props.maintenanceGraphData}
              level={this.props.maintenanceGraphLevel}
              onClick={this.onChartClick}
            />
            <PerformanceTimeTable
              graphData={this.props.maintenanceGraphData}
              level={this.props.maintenanceGraphLevel}
              onClick={this.goToUserTickets}
              timePeriod={this.state.timePeriod}
            />
          </div>
          <div className="row">
            <TimeCompletePriorityChart
              graphData={this.props.maintenanceGraphData}
              onClick={this.onChartClick}
              level={this.props.maintenanceGraphLevel}
              showLabels={this.state.showLabels}
              timeSeries={this.state.timeSeries}
              timePeriod={this.state.timePeriod}
            />
            <TimeCompleteCategoryChart
              graphData={this.props.maintenanceGraphData}
              onClick={this.onChartClick}
              level={this.props.maintenanceGraphLevel}
              showLabels={this.state.showLabels}
              timeSeries={this.state.timeSeries}
              timePeriod={this.state.timePeriod}
            />
            <TicketsTable
              graphData={this.props.maintenanceGraphData}
              goToTicket={this.toggleDrawer}
              level={this.props.maintenanceGraphLevel}
              timePeriod={this.state.timePeriod}
            />
          </div>
          <div style={{ height: '50px' }} />
        </Fragment>
      );
    };

    _renderHeader = () => {
      if (this.props.loadingMaintenanceGraphData) return null;
      const { maintenanceGraphData, maintenanceGraphLevel } = this.props;
      const timeRange =
        maintenanceGraphData[maintenanceGraphLevel] &&
        maintenanceGraphData[maintenanceGraphLevel].time_range === 'day'
          ? 'Sort by Day'
          : 'Sort by Month';
      return (
        <div className="row" style={{ margin: '10px 0 15px' }}>
          <div className="col-sm-4">
            <MultiSelectExtended
              onChange={this.setInsightsRange}
              name="insights_range"
              floatingLabel="Range"
              data={ranges}
              menuStyle={{ fontSize: '14px' }}
              textFieldStyle={{ padding: 0 }}
              style={{ fontSize: '14px' }}
              minHeight={'32px'}
              fullWidth
              value={this.state.range}
            />
          </div>
          <div className="col-sm-4">
            <Toggle
              label={timeRange}
              labelPosition="left"
              style={{ marginLeft: '10px' }}
              toggled={this.state.timeSeries}
              onToggle={() => this.setState(prevState => ({ timeSeries: !prevState.timeSeries }))}
            />
            <Toggle
              label="View Hours"
              labelPosition="left"
              style={{ marginLeft: '10px' }}
              toggled={this.state.timePeriod === 'hours'}
              onToggle={this.changeTimePeriod}
            />
          </div>
          <div className="col-sm-4">
            <Toggle
              label="Show Table"
              labelPosition="left"
              style={{ marginLeft: '10px' }}
              toggled={this.state.showTable}
              onToggle={() => this.setState(prevState => ({ showTable: !prevState.showTable }))}
            />
            <Toggle
              label="Show Labels"
              labelPosition="left"
              style={{ marginLeft: '10px' }}
              toggled={this.state.showLabels}
              onToggle={() => this.setState(prevState => ({ showLabels: !prevState.showLabels }))}
            />
          </div>
          {this.state.range.value === 'day' && (
            <div className="col-sm-12">
              <div className="row">
                <div className="col-sm-8" style={{ paddingLeft: 0 }}>
                  <DateRangePicker
                    onChange={dateRange => this.setState({ dateRange })}
                    value={this.state.dateRange}
                  />
                </div>
                <div className="col-sm-4">
                  <FlatButton
                    label="Apply"
                    type="button"
                    primary={true}
                    backgroundColor={AccentColor()}
                    hoverColor="grey"
                    style={{ color: 'white' }}
                    onClick={this.populateDateRange}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    _renderBreadCrumb = () => {
      if (!this.props.maintenanceGraphLevel || this.props.loadingMaintenanceGraphData) return null;
      if (this.state.showUserTickets) return null;
      const { maintenanceGraphData, maintenanceGraphLevel } = this.props;
      const { indexArray } = this.state;
      if (indexArray.length === 0) return null;

      const index = indexArray.length - 1;
      return (
        <div className="row">
          <p style={{ margin: 0, padding: 0 }}>
            <strong>{maintenanceGraphData[maintenanceGraphLevel].insight_type_name}</strong>
          </p>
          <span
            style={{ float: 'left', cursor: 'pointer' }}
            onClick={() => this.stepToParent(index)}
          >
            <small>
              back to {indexArray[index].type}: {indexArray[index].label}
            </small>
          </span>
        </div>
      );
    };

    _renderActionInsights = () => {
      if (!this.props.maintenanceGraphLevel || this.props.loadingMaintenanceGraphData) return null;
      if (this.state.showUserTickets) return null;
      const avgTimeData = () => {
        return formatHoursDays(
          this.props.maintenanceGraphData[this.props.maintenanceGraphLevel].avg_time_fix_minutes,
          this.state.timePeriod
        );
      };
      const ticketClosedData = () => {
        return this.props.maintenanceGraphData[this.props.maintenanceGraphLevel]
          .tickets_closed_count;
      };
      const ticketOpenedData = () => {
        return this.props.maintenanceGraphData[this.props.maintenanceGraphLevel]
          .tickets_opened_count;
      };
      const satisfactionData = () => {
        return this.props.maintenanceGraphData[this.props.maintenanceGraphLevel]
          .tickets_satisfaction_rate;
      };
      return (
        <div className="row" style={{ paddingBottom: '5px' }}>
          {this.renderDashboardOverviewTile(
            avgTimeData(),
            `Avg Time to Fix (${this.state.timePeriod})`
          )}
          {this.renderDashboardOverviewTile(ticketClosedData(), 'Tickets Closed')}
          {this.renderDashboardOverviewTile(ticketOpenedData(), 'Tickets Opened')}
          {this.renderDashboardOverviewTile(satisfactionData(), 'Average Satisfaction')}
        </div>
      );
    };

    renderDashboardOverviewTile = (overviewHighlight, itemDescription) => (
      <div
        className="col-sm-3 col-xs-6"
        style={{ textAlign: 'center', margin: '10px 0', padding: '0 15px' }}
      >
        <Card style={{ ...style.transactionCard, padding: 0 }}>
          <CardText expandable={true} style={{ padding: '15px' }}>
            <h3 style={{ margin: 0, fontSize: '30px' }}>{overviewHighlight}</h3>
            <hr
              style={{
                maxWidth: '35px',
                margin: '12px auto',
                borderTop: `3px solid ${AccentColor()}`,
              }}
            />
            <p style={{ fontFamily: 'Circular', margin: 0 }}>{itemDescription}</p>
          </CardText>
        </Card>
      </div>
    );
  }
);
